import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { RecommendAgentService } from "@app/core/services/recommend-agent.service";
import { ResultStatus } from "@app/core/models/result-status";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { HelperService } from "@app/core/services/helper.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { DomSanitizer } from "@angular/platform-browser";
import { RecommendAgentComponent } from "../recommend-agent/recommend-agent.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-manage-recommendations",
  templateUrl: "./manage-recommendations.component.html",
  styleUrls: ["./manage-recommendations.component.scss"],
})
export class ManageRecommendationsComponent implements OnInit {
  @ViewChild("deleteRecommendationTemplate") deleteMessageTemplate: ElementRef;
  // @ViewChild("askForRevisionTemplate") askForRevisionTemplate: ElementRef;
  isDataLoaded = false;
  receiveRecommendationList = [];
  givenRecommendationList = [];
  isActive = false;
  modalRef: BsModalRef;
  deleteConfirmationId;
  agentID = 0;
  constructor(
    private recommendAgentService: RecommendAgentService,
    private authService: AuthenticationService,
    private helperService: HelperService,
    private modalService: BsModalService,
    public bsmodalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService
  ) {
    this.agentID = this.modalService.config.initialState["agentId"];
  }

  ngOnInit() {
    this.getRecommendations();
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanitizer.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanitizer.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  getRecommendations() {
    this.recommendAgentService.getRecommendation().subscribe(
      (result) => {
        this.isDataLoaded = true;
        if (result.Status === ResultStatus.Success) {
          this.receiveRecommendationList = result.Data.Receive;
          this.givenRecommendationList = result.Data.Given;
        } else {
        }
      },
      (error) => { }
    );
  }

  acceptRejectRecommendation(id, isAccept) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(id)) {
      this.recommendAgentService
        .acceptRejectRecommendation(id, isAccept)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.isDataLoaded = false;
            this.getRecommendations();
          }
        });
    }
  }

  deleteRecommendation() {
    if (
      !this.helperService.isUndefinedOrNullOrEmpty(this.deleteConfirmationId)
    ) {
      this.recommendAgentService
        .deleteRecommendation(this.deleteConfirmationId)
        .subscribe(
          (result) => {
            if (result.Status === ResultStatus.Success) {
              this.modalRef.hide();
              this.isDataLoaded = false;
              this.getRecommendations();
            }
          },
          (error) => { }
        );
    }
  }

  changeRecommendation(id, isVisible) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(id)) {
      this.recommendAgentService
        .changeRecommendationVisibility(id, isVisible)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getRecommendations();
          }
        });
    }
  }

  openDeleteConfirmation(id: any) {
    this.deleteConfirmationId = id;
    this.modalRef = this.modalService.show(
      this.deleteMessageTemplate,
      Object.assign({}, { class: "custom-modal update-modal modal-lg" })
    );
  }

  trackByReceivedID(index, item) {
    return item.ID;
  }

  trackByGivenID(index, item) {
    return item.ID;
  }

  reviseRecommendation(ID) {
    const initialState = {
      id: ID,
      agentId: this.agentID,
    };
    this.modalRef = this.modalService.show(
      RecommendAgentComponent,
      { initialState, backdrop: 'static', class: "modal-lg" }
    );
    this.modalRef.content.closeBtnName = "Close";

    this.modalService.onHide.subscribe((result) => {
      this.getRecommendations();
    });
  }

  closeModal() {
    this.bsmodalRef.hide();
  }

  askForRevision(id) {
    this.recommendAgentService.askForRevise(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        // this.modalRef = this.modalService.show(
        //   this.askForRevisionTemplate,
        //   Object.assign({}, { class: "custom-modal update-modal modal-lg" })
        // );
        this.toastrService.success('Revise recommendation request has been send successfully.');
      }
    });
  }
}
